import * as Community from '../constants/Community';

const initialState = {
  community: null,
  createLoaded: false,
  createdId: null,
  destroyed: null,
  previewCommunity: null,
  updateLoaded: false,
  publishLoaded: false,
  joined: false,
  appliedUsers: null,
  appliedLoad: false,
  previewMode: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Community.COMMUNITY_CREATE:
      return state;
    
    case Community.COMMUNITY_CREATE_RESULT:
      return Object.assign({}, state, {
        createLoaded: true,
        community: action.community
      });

    case Community.COMMUNITY_CREATE_RESET:
      return Object.assign({}, state, {
        createLoaded: false
      });
    
    case Community.COMMUNITY_INFO_GET:
      return state
    
    case Community.COMMUNITY_INFO_GET_RESULT:
      if (action.preview) {
        return Object.assign({}, state, {
          previewCommunity: action.community
        });
      } else {
        return Object.assign({}, state, {
          community: action.community
        });
      }

    case Community.COMMUNITY_INFO_REMOVE:
      return Object.assign({}, state, {
        community: null,
        joined: false,
        publishLoaded: false,
        createLoaded: false,
        destroyed: false
      });
    
    case Community.COMMUNITY_UPDATE_RESULT:
      return Object.assign({}, state, {
        community: action.community,
        updateLoaded: true
      });
    case Community.COMMUNITY_UPDATE_RESET:
      return Object.assign({}, state, {
        updateLoaded: false
      })
    
    case Community.COMMUNITY_CREATED_FLAG_REMOVE:
      return Object.assign({}, state, {
        createLoaded: false,
        createdId: null
      });
    case Community.COMMUNITY_DESTROY:
      return state;
    case Community.COMMUNITY_DESTROY_RESULT:
      return Object.assign({}, state, {
        destroyed: true
      });
    case Community.COMMUNITY_DESTROY_FLAG_REMOVE:
      return Object.assign({}, state, {
        destroyed: null
      });
    
    case Community.COMMUNITY_PREVIEW_SET:
      if (action.formData) {
        return Object.assign({}, state, {
          previewCommunity: action.community,
          updateFormData: action.formData,
          previewMode: true
        });
      } else {
        return Object.assign({}, state, {
          previewCommunity: action.community,
          previewMode: true
        });
      }

    case Community.COMMUNITY_PREVIEW_BACK:
      return Object.assign({}, state, {
          previewMode: false
        })
  
    case Community.COMMUNITY_PREVIEW_DELETE:
      return Object.assign({}, state, {
        previewCommunity: null
      });
    
    case Community.COMMUNITY_PUBLISH_RESULT: 
      return Object.assign({}, state, {
        publishLoaded: true,
        community: action.community
      })
    
    case Community.COMMUNITY_JOIN_RESULT:
      return Object.assign({}, state, {
        joined: true
      })
    
    case Community.COMMUNITY_JOIN_RESET:
      return Object.assign({}, state, {
        joined: false
      })
    
    case Community.COMMUNITY_GET_APPLIED:
      return Object.assign({}, state, {
        appliedUsers: action.result,
        appliedLoad: true
      })
    
    case Community.COMMUNITY_GET_APPLIED_RESET:
      return Object.assign({}, state, {
        appliedUsers: null,
        appliedLoad: false
      })

    case Community.COMMUNITY_ALL_RESET:
      return {
        community: null,
        createLoaded: false,
        createdId: null,
        destroyed: null,
        previewCommunity: null,
        updateLoaded: false,
        publishLoaded: false,
        joined: false,
        appliedUsers: null,
        appliedLoad: false
      }
    
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/Community.js